import { createContext } from "react";

import { FeatureFlag } from "@/lib/types";

export const FeatureFlagContext = createContext<FeatureFlag[]>([]);
